// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1WZbT","range":"MonthRangeSwitch_range__17eY2","disabled":"MonthRangeSwitch_disabled__3A27m"};